import { FetchResult } from 'src/types/TApiQueries';
import {
  NotificationSettings,
  NotificationSettingsUpdatePayload,
} from 'src/types/TNotificationSettings';
import { config } from 'src/utils/config';
import { getStandardHeaders, performFetchWithLogging } from '../utils/helpers';

const baseUrl = config.hostUrl;

export async function getNotificationSettings(
  accessToken: string,
): Promise<FetchResult<NotificationSettings>> {
  return performFetchWithLogging(`${baseUrl}/api/v1/usergroup/settings/notifications`, {
    method: 'GET',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
  });
}

export async function updateNotificationSettings(
  data: NotificationSettingsUpdatePayload,
  accessToken: string,
): Promise<FetchResult<NotificationSettings>> {
  return performFetchWithLogging(`${baseUrl}/api/v1/usergroup/settings/notifications`, {
    method: 'PUT',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
    body: JSON.stringify(data),
  });
}
